import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const TwitterIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 21 20"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M8.02 15.83C6.48 15.83 5.04 15.39 3.83 14.63C4.86 14.69 6.67 14.53 7.8 13.47C6.1 13.39 5.34 12.11 5.24 11.56C5.38 11.61 6.07 11.68 6.46 11.53C4.51 11.04 4.21 9.35 4.28 8.83C4.64 9.09 5.26 9.18 5.5 9.15C3.69 7.87 4.34 5.93 4.66 5.52C5.97 7.3 7.92 8.31 10.34 8.36C10.29 8.16 10.27 7.96 10.27 7.75C10.27 6.23 11.51 5 13.04 5C13.83 5 14.55 5.34 15.06 5.87C15.59 5.75 16.4 5.46 16.79 5.21C16.59 5.91 15.98 6.5 15.6 6.72C15.6 6.71 15.61 6.72 15.6 6.72C15.93 6.67 16.82 6.5 17.17 6.26C16.99 6.66 16.34 7.32 15.8 7.68C15.9 12.04 12.54 15.83 8.02 15.83Z" />
		</svg>
	)
}

export default TwitterIcon
